<script>
  import { afterUpdate } from "svelte";
  import {
    f7,
    Swiper,
    SwiperSlide,
    Preloader,
    Row,
    Col
  } from "framework7-svelte";
  import { getFirestore } from "./Firestore.js";
  import ProductLayoutMenu, {
    SINGLE_ROW,
    SINGLE_COL,
    DOUBLE_COL
  } from "./ProductLayoutMenu.svelte";
  import ProductItem from "./ProductItem.svelte";
  import { createProductLayout } from "./stores.js";

  export let f7router;
  export let f7route;

  let initialSlide = 0;
  let productId = f7route.query.productId ? f7route.query.productId : undefined;
  let productLayout = createProductLayout(f7route.query.layout);
  let products = null;
  let scrolledIntoView = productId === undefined ? true : false;

  afterUpdate(() => {
    if (!scrolledIntoView) {
      let div = document.getElementById(productId);
      if (div) {
        div.scrollIntoView();
        scrolledIntoView = true;
      }
    }
  });

  function load(tag) {
    getFirestore().then(function(firestore) {
      let query = firestore.collection("products");
      if (tag && tag.length > 0) {
        query = query.where("tags", "array-contains", tag);
      }
      query.orderBy("price").onSnapshot(function(querySnapshot) {
        let i = 0;
        let result = [];
        querySnapshot.forEach(doc => {
          let product = doc.data();
          product.id = doc.id;

          if (doc.id === productId) {
            initialSlide = i;
          }
          result.push(product);
          i++;
        });

        products = result;
      });
    });
  }

  let tag = f7route.path.split("/")[2].toLowerCase();
  load(tag);

  function getRowsWith2Cols(products) {
    let rows = [];
    let cols;
    for (var i = 0; i < products.length; i++) {
      if (i % 2 === 0) {
        cols = [];
        rows.push(cols);
      }
      cols.push(products[i]);
    }
    return rows;
  }
</script>

<div style="height: 100%">
  <ProductLayoutMenu {productLayout} />

  {#if !products}
    <div
      style="align-items: center; display: flex; justify-content: center;
      flex-direction: column; height: 100%;">

      <Preloader />
    </div>
  {:else if $productLayout === SINGLE_ROW}
    <Swiper
      style="height: 100%"
      params={{ initialSlide: initialSlide }}
      pagination
      navigation>
      {#each products as product}
        <SwiperSlide style="text-align: center">
          <div style="padding-top: 60px" class="page-content">
            <ProductItem {product} {productLayout} {f7router} />
          </div>
        </SwiperSlide>
      {/each}
    </Swiper>
  {:else if $productLayout === SINGLE_COL}
    <div style="padding-top: 60px" class="page-content">
      <Row>
        <Col>
          {#each products as product}
            <div style="width: 100%; text-align: center">
              <ProductItem {product} {productLayout} {f7router} />
            </div>
            <hr />
          {/each}
        </Col>
      </Row>
    </div>
  {:else if $productLayout === DOUBLE_COL}
    <div style="padding-top: 60px" class="page-content">
      {#each getRowsWith2Cols(products) as row}
        <Row>
          {#each row as product}
            <Col>
              <div style="width: 100%; text-align: center">
                <ProductItem
                  {product}
                  length={row.length}
                  {productLayout}
                  {f7router} />
              </div>
            </Col>
          {/each}
        </Row>
        <hr />
      {/each}
    </div>
  {/if}
</div>
